import { Component, React } from 'react';
import Chart from 'react-google-charts';
import memberData from './memberData.json'

class MakeChart extends Component {
  render() {
    let i = 0
    let num_first_grade = 0
    let num_second_grade = 0
    let num_third_grade = 0
    let num_fourth_grade = 0

    let classof_eighteen = 0
    let classof_nineteen = 0
    let classof_twenty = 0
    let classof_twentyone = 0
    let classof_twentytwo = 0
    let classof_twentythree = 0
    let classof_twentyfour = 0
    let classof_twentyfive = 0
    let classof_twentysix = 0

    let j = 0
    let num_ai = 0
    let num_game = 0
    let num_algorithm = 0
    let num_security = 0
    let num_data = 0
    let num_web = 0
    let num_frontend = 0
    let num_backend = 0
    let num_java = 0
    let num_c = 0

    while (i < memberData.length) {
      if (memberData[i].grade === '1') {
        num_first_grade = num_first_grade + 1
      } else if (memberData[i].grade === '2') {
        num_second_grade = num_second_grade + 1
      } else if (memberData[i].grade === '3') {
        num_third_grade = num_third_grade + 1
      } else if (memberData[i].grade === '4') {
        num_fourth_grade = num_fourth_grade + 1
      }
      i = i + 1
    }

    i = 0
    while (i < memberData.length) {
      if (memberData[i].classof === '18학번') {
        classof_eighteen = classof_eighteen + 1
      } else if (memberData[i].classof === '19학번') {
        classof_nineteen = classof_nineteen + 1
      } else if (memberData[i].classof === '20학번') {
        classof_twenty = classof_twenty + 1
      } else if (memberData[i].classof === '21학번') {
        classof_twentyone = classof_twentyone + 1
      } else if (memberData[i].classof === '22학번') {
        classof_twentytwo =  classof_twentytwo + 1
      } else if (memberData[i].classof === '23학번') {
        classof_twentythree = classof_twentythree + 1
      } else if (memberData[i].classof === '24학번') {
        classof_twentyfour = classof_twentyfour + 1
      } else if (memberData[i].classof === '25학번') {
        classof_twentyfive = classof_twentyfive + 1
      } else if (memberData[i].classof === '26학번') {
        classof_twentysix = classof_twentysix + 1
      }

      i = i + 1
    }

    i = 0
    while (i < memberData.length) {
      j = 0
      while (j < memberData[i].Team.length) {
        if (memberData[i].Team[j] === 'AI') {
          num_ai += 1
        } else if (memberData[i].Team[j] === 'DATA') {
          num_data += 1
        } else if (memberData[i].Team[j] === 'WEB') {
          num_web += 1
        } else if (memberData[i].Team[j] === '게임') {
          num_game += 1
        } else if (memberData[i].Team[j] === '알고리즘') {
          num_algorithm += 1
        } else if (memberData[i].Team[j] === '보안') {
          num_security += 1
        } else if (memberData[i].Team[j] === 'C') {
          num_c += 1
        } else if (memberData[i].Team[j] === '프론트엔드') {
          num_frontend += 1
        } else if (memberData[i].Team[j] === '백엔드') {
          num_backend += 1
        } else if (memberData[i].Team[j] === 'JAVA') {
          num_java += 1
        }
        j = j + 1
      }
      i = i + 1
    }
    return (
        <div class="flex py-2 inset-x-0 overflow-auto lg:mx-10 xl:mx-30">
          <div class="relative inset-x-0 md:w-2/6">
            <Chart
              // width={'331px'}
              // height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart...</div>}
              data={[
                ['Grade', 'Number'],
                ['1학년', num_first_grade],
                ['2학년', num_second_grade],
                ['3학년', num_third_grade],
                ['4학년', num_fourth_grade],
              ]}
              options={{
                title: 'Grade',
                colors: ['#4B088A', '#5F04B4', '#7401DF', '#8000FF'],
                fontSize: 13,
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>
          <div class="md:w-2/6">
            <Chart
              // width={'30vw'}
              // height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart...</div>}
              data={[
                ['ClassOf', 'Number'],
                ['18학번', classof_eighteen],
                ['19학번', classof_nineteen],
                ['20학번', classof_twenty],
                ['21학번', classof_twentyone],
                ['22학번', classof_twentytwo],
                ['23학번', classof_twentythree],
                ['24학번', classof_twentyfour],
                ['25학번', classof_twentyfive],
                ['26학번', classof_twentysix],
              ]}
              options={{
                title: 'ClassOf',
                colors: [
                  '#4B088A',
                  '#5F04B4',
                  '#7401DF',
                  '#8000FF',
                  '#9A2EFE',
                  '#AC58FA',
                  '#BE81F7',
                  '#D1A3FF',
                  '#E8DAEF',
                ],
                fontSize: 13,
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div>
          <div class="md:w-2/6">
            <Chart
              // width={'30vw'}
              // height={'300px'}
              chartType="PieChart"
              loader={<div>Loading Chart...</div>}
              data={[
                ['Team', 'Number'],
                ['AI', num_ai],
                ['게임', num_game],
                ['알고리즘', num_algorithm],
                ['보안', num_security],
                // ['Data', num_data],
                ['Web', num_web],
                ['프론트엔드', num_frontend],
                ['백엔드', num_backend],
                ['C', num_c],
                ['JAVA', num_java],
              ]}
              options={{
                title: 'Team',
                colors: [
                  '#4B088A',
                  '#5F04B4',
                  '#7401DF',
                  '#8000FF',
                  '#9A2EFE',
                  '#AC58FA',
                  '#BE81F7',
                  '#D1A3FF',
                  '#E8DAEF',
                ],
                fontSize: 13,
              }}
              rootProps={{ 'data-testid': '1' }}
            />
          </div> 
        </div>
    )
  }
}
export default MakeChart;

/*
class MakeChart extends Component {
  render() {
    let i = 0
    let num_first_grade = 0
    let num_second_grade = 0
    let num_third_grade = 0
    let num_fourth_grade = 0
    
    let classof_fifteen = 0
    let classof_sixteen = 0
    let classof_seventeen = 0
    let classof_eighteen = 0
    let classof_nineteen = 0
    let classof_twenty = 0
    let classof_twentyone = 0
    
    let j = 0
    let num_ai = 0
    let num_game = 0
    let num_algorithm = 0
    let num_security = 0
    let num_data = 0
    let num_web = 0

    while (i < memberData.length) {
      if (memberData[i].grade === '1') {
        num_first_grade = num_first_grade + 1
      } else if (memberData[i].grade === '2') {
        num_second_grade = num_second_grade + 1
      } else if (memberData[i].grade === '3') {
        num_third_grade = num_third_grade + 1
      } else if (memberData[i].grade === '4') {
        num_fourth_grade = num_fourth_grade + 1
      }
      i = i + 1
    }

    i = 0
    while (i < memberData.length) {
      if (memberData[i].classof === '15학번') {
        classof_fifteen = classof_fifteen + 1
      } else if (memberData[i].classof === '16학번') {
        classof_sixteen = classof_sixteen + 1
      } else if (memberData[i].classof === '17학번') {
        classof_seventeen = classof_seventeen + 1
      } else if (memberData[i].classof === '18학번') {
        classof_eighteen = classof_eighteen + 1
      } else if (memberData[i].classof === '19학번') {
        classof_nineteen = classof_nineteen + 1
      } else if (memberData[i].classof === '20학번') {
        classof_twenty = classof_twenty + 1
      } else if (memberData[i].classof === '21학번') {
        classof_twentyone = classof_twentyone + 1
      }
      i = i + 1
    }

    i = 0
    while (i < memberData.length) {
      j = 0
      while (j < memberData[i].Team.length) {
        if (memberData[i].Team[j] === 'AI') {
          num_ai += 1
        } else if (memberData[i].Team[j] === 'DATA') {
          num_data += 1
        } else if (memberData[i].Team[j] === 'WEB') {
          num_web += 1
        } else if (memberData[i].Team[j] === '게임') {
          num_game += 1
        } else if (memberData[i].Team[j] === '알고리즘') {
          num_algorithm += 1
        } else if (memberData[i].Team[j] === '보안') {
          num_security += 1
        }
        j = j + 1
      }
      i = i + 1

    }
    return (
      <div class="flex flex-row">
        <Chart
          width={'500px'}
          height={'300px'}
          chartType="PieChart"
          loader={<div>Loading Chart...</div>}
          data={[
            ['Grade', 'Number'],
            ['1학년', num_first_grade],
            ['2학년', num_second_grade],
            ['3학년', num_third_grade],
            ['4학년', num_fourth_grade],
          ]}
          options={{
            title: 'Grade',
            colors: ['#4B088A', '#5F04B4', '#7401DF', '#8000FF'],
            fontSize: 13,
          }}
          rootProps={{ 'data-testid': '1' }}
        />
        <Chart
          width={'500px'}
          height={'300px'}
          chartType="PieChart"
          loader={<div>Loading Chart...</div>}
          data={[
            ['ClassOf', 'Number'],
            ['15학번', classof_fifteen],
            ['16학번', classof_sixteen],
            ['17학번', classof_seventeen],
            ['18학번', classof_eighteen],
            ['19학번', classof_nineteen],
            ['20학번', classof_twenty],
            ['21학번', classof_twentyone],
          ]}
          options={{
            title: 'ClassOf',
            colors: [
              '#4B088A',
              '#5F04B4',
              '#7401DF',
              '#8000FF',
              '#9A2EFE',
              '#AC58FA',
              '#BE81F7',
            ],
            fontSize: 13,
          }}
          rootProps={{ 'data-testid': '1' }}
        />
        <Chart
          width={'500px'}
          height={'300px'}
          chartType="PieChart"
          loader={<div>Loading Chart...</div>}
          data={[
            ['Team', 'Number'],
            ['AI', num_ai],
            ['게임', num_game],
            ['알고리즘', num_algorithm],
            ['보안', num_security],
            ['Data', num_data],
            ['Web', num_web],
          ]}
          options={{
            title: 'Team',
            colors: [
              '#4B088A',
              '#5F04B4',
              '#7401DF',
              '#8000FF',
              '#9A2EFE',
              '#AC58FA',
            ],
            fontSize: 13,
          }}
          rootProps={{ 'data-testid': '1' }}
        />
      </div>
    )
  }
}

export default MakeChart;
*/